import React from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'

import {
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Checkbox
} from '@mui/material';

const AccountInfo = props => {
  const { onChange, name, website, primaryContactEmail, memberEmailDomain, integrator, account_view, is_dm_admin} = props;
  
  let title = "Funder Info"
  if (account_view) {
    title = "Account Info"
  }
  return (
    <React.Fragment>
      <CardHeader
        title={title}
      />
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            size={{xs:12, md:12}}
          >
            {is_dm_admin && process.env.REACT_APP_ENVIRONMENT === 'SANDBOX' ? 
            <FormControlLabel
              control={<Checkbox
                checked={integrator === true ? true : false}
                color="primary"
                onChange={event => onChange(event, 'integrator')}
                value="true"
              />}
              label="Integration Partner"
            />
            :
            null
            }
          </Grid>
          <Grid
            size={{xs:12, md:12}}
          >
            {is_dm_admin ? 
              <TextField
              fullWidth
              label="Funder name"
              margin="dense"
              name="name"
              onChange={(event) => onChange(event, 'name')}
              required
              value={name || ''}
              variant="outlined"
            />
            :
            <TextField
            fullWidth
            label="Funder name"
            margin="dense"
            name="name"
            onChange={(event) => onChange(event, 'name')}
            required
            value={name || ''}
            variant="outlined"
            disabled
          />
            }
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="Website"
              margin="dense"
              name="website"
              onChange={(event) => onChange(event, 'website')}
              required
              value={website || ''}
              variant="outlined"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="Primary Contact Email"
              margin="dense"
              name="primaryContactEmail"
              onChange={(event) => onChange(event, 'primaryContactEmail')}
              required
              value={primaryContactEmail || ''}
              variant="outlined"
            />
          </Grid>
          { is_dm_admin ? 
          <Grid
          size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="Member Email Domain"
              margin="dense"
              name="memberEmailDomain"
              onChange={(event) => onChange(event, 'memberEmailDomain')}
              required
              value={memberEmailDomain || ''}
              variant="outlined"
              helperText="Separate multiple domains with a comma"
            />
          </Grid>
          : null }
        </Grid>
      </CardContent>
    </React.Fragment>
  );
};

export default withErrorHandler(AccountInfo, axios)